import { useState } from "react";
import { Input, Textarea, Badge } from "@mantine/core";
import { useCellRender } from "../hooks/useCellRender";

const AIRequestDocOutputs = ({ form, name, label }) => {
  const aiRequest = form.values;
  const outputs = aiRequest.outputs || [];
  const [cellRender] = useCellRender();

  const getUrl = (docType) => {
    switch (docType) {
      case "DEBIT_NOTE":
        return "/m/gi/debitNote";
      case "QUOTATION":
        return "/m/gi/quotation";
      case "RENEWAL":
        return "/m/gi/renewal";
      case "ENDORSEMENT":
        return "/m/gi/endorsement";
    }
  };

  const getDocTypeColor = (docType) => {
    switch (docType) {
      case "DEBIT_NOTE":
        return "green";
      case "QUOTATION":
        return "blue";
      case "RENEWAL":
        return "orange";
      case "ENDORSEMENT":
        return "purple";
      default:
        return "gray";
    }
  };

  return <div>{cellRender.AIRequestOutputs(aiRequest)}</div>;
};

export default AIRequestDocOutputs;
